"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Chip = {
  defaultProps: {
    selectedColor: "baseContrast010"
  },
  styles: function styles(theme) {
    return {
      root: {
        background: theme.colors.pageBackground,
        borderColor: theme.colors.baseContrast030,
        borderStyle: "solid",
        borderWidth: 1,
        fontFamily: 'Raleway, "Helvetica Neue", "Helvetica", "Arial", sans-serif',
        letterSpacing: 0.51
      },
      inputRelated: {
        "&:has(input:disabled)": {
          borderColor: theme.colors.baseContrast040
        }
      }
    };
  }
};
var _default = exports.default = Chip;